import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20c0-.87-2.609-20-2.609-20L20 0Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#ACABB1",
  d: "m27.659 17.403 3.758 4.973a2.61 2.61 0 1 0 1.387-1.049l-5.857-7.75-3.469 2.622 2.098 2.775 2.082-1.57Zm5.41 5.717a.87.87 0 1 1 1.05 1.387.87.87 0 0 1-1.05-1.387Z"
}, null, -1), i = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "m34.105 18.974 2.098-2.775-3.469-2.621-5.858 7.749a2.61 2.61 0 1 0 1.388 1.049l3.758-4.973 2.083 1.571Zm-7.324 5.364a.87.87 0 1 1-1.388-1.048.87.87 0 0 1 1.387 1.048Z"
}, null, -1), a = [
  n,
  c,
  s,
  i
];
function d(_, h) {
  return e(), l("svg", o, [...a]);
}
const m = { render: d };
export {
  m as default,
  d as render
};
